.host {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 92.7rem;
  min-height: 48.4rem;
  padding: 0;
  overflow: hidden;
}

.header {
  padding: 4.8rem 4.8rem 3.2rem;
  background: var(--color-athens-grey);
  border-top-left-radius: 2.4rem;
  border-top-right-radius: 2.4rem;
}

.rounded {
  border-top-left-radius: 2.4rem;
  border-top-right-radius: 2.4rem;
}

.icon {
  color: var(--color-peach-orange);
}

.icon svg {
  width: 2.4rem;
  height: 2.4rem;
}

.title {
  margin-top: 2rem;
  color: var(--color-semantic-text-neutral30);
}

.subtitle {
  margin-top: 2rem;
  color: var(--color-semantic-text-neutral30);
  font-size: 1.6rem;
  line-height: 2.6rem;
}

.content {
  flex: 1;
  padding: 4.8rem 4.8rem 6.4rem;
  background: var(--color-white);
  border-bottom-right-radius: 2.4rem;
  border-bottom-left-radius: 2.4rem;
}

.content.withFooter {
  padding-bottom: 0;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.4rem 4.8rem;
  border-top: solid 0.1rem var(--color-athens-grey);
}

.footerSpacing {
  margin-top: 4.8rem;
}

.actions > button + button {
  margin-left: 2rem;
}

.navigationSteps {
  display: flex;
}

.navigationStep {
  width: 0.4rem;
  height: 0.4rem;
  background-color: var(--color-semantic-surface-neutral40);
  border-radius: 50%;
  transition: all 0.15s ease-in;
}

.navigationStep.active {
  width: 2rem;
  background-color: var(--color-semantic-surface-accentSecondary40);
  border-radius: 0.4rem;
}

.navigationStep:not(:first-child) {
  margin-left: 1rem;
}
